<template>
<div class="feature-box">
    <a href="##" @click.prevent="clickFunc">
        <div class="heading">
            {{ title }}
        </div>
        <div class="content">
            <i :class="featureClass"></i>
        </div>
    </a>
</div>
</template>

<script>

export default {
    props: ['title', 'featureClass', 'clickFunc']
}
</script>